import { render, staticRenderFns } from "./ExternalTextInput.vue?vue&type=template&id=066b21a4"
import script from "./ExternalTextInput.vue?vue&type=script&lang=js"
export * from "./ExternalTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports